import { render } from "./EmailPage.vue?vue&type=template&id=5fe3d512&scoped=true"
import script from "./EmailPage.vue?vue&type=script&lang=js"
export * from "./EmailPage.vue?vue&type=script&lang=js"

import "./EmailPage.vue?vue&type=style&index=0&id=5fe3d512&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe3d512"]])

export default __exports__